import { useContext } from 'react';
import { WarehouseAppContext } from '../context/WarehouseAppContext';

export const useWarehouseAppContext = () => {
  const context = useContext(WarehouseAppContext);
  if (!context) {
    throw new Error('useWarehouseAppContext must be used within WarehouseAppContext.Provider');
  }
  return context;
};
